import { render, staticRenderFns } from "./ManufactureProductModal.vue?vue&type=template&id=06e31fa5&scoped=true&"
import script from "./ManufactureProductModal.vue?vue&type=script&lang=js&"
export * from "./ManufactureProductModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e31fa5",
  null
  
)

export default component.exports